export default {
  computed: {
    item() {
      return this.productSet;
    },
  },
  methods: {
    selectSet() {
      this.$router.push({hash: '#set'});
      this.$store.dispatch('SET_SET', this.item);
    }
  }
};
